import { faBaby } from "@fortawesome/free-solid-svg-icons";
import { memo } from "react";

import Percentage from "../components/Percentage";
import CustomWidget from "./CustomWidget";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import LineChart from "../components/ProgressBarChart";
import "./Widget2.css";

const Widget2 = ({ data }) => {
  const { t } = useTranslation();
  if (!data) return null;

  //const childrenUnder5 = +data.childrenUnder5?.[0]?.[2] || 0;
  //const earlyInit = +data.earlyInit?.[0]?.[1] || 0;
  console.log({ data });
  const exclusiveBreastfeeding = +data.exclusiveBreastfeeding?.[0]?.[1] || 0;

  const childrenUnder5 = 46;
  const earlyInit = 76;
  // const exclusiveBreastfeeding = 84;

  return (
    <div className="top-widget-container">
      <CustomWidget title="" style={{ minWidth: 470 }}>
        <Percentage
          data={childrenUnder5} // TODO: remove this hardcode
          unit={"%"}
          icon={faBaby}
          numberOfIcon={10}
          text={t("Children under 5 accessed growth monitoring")}
          backgroundColor={["#31589d", "#eca91d"]}
        />
      </CustomWidget>
      <CustomWidget>
        <Box sx={{ padding: { xs: "0 5px", md: "0 20px" } }}>
          <LineChart
            title={
              <div style={{ fontSize: "18px" }}>
                {t("Early initiation of breastfeeding under 90 mts")}
              </div>
            }
            data={earlyInit.toFixed(0)}
            fontSize={24}
          />
        </Box>
      </CustomWidget>

      <CustomWidget title="">
        <Box sx={{ padding: { xs: "0 5px", md: "0 20px" } }}>
          <LineChart
            title={
              <div style={{ fontSize: "18px" }}>
                {t("Exclusive breastfeeding until discharge")}
              </div>
            }
            data={exclusiveBreastfeeding.toFixed(0)}
            fontSize={24}
          />
        </Box>
      </CustomWidget>
    </div>
  );
};

export default memo(Widget2);
